import { render, staticRenderFns } from "./FocusButton.vue?vue&type=template&id=1b6e874b&scoped=true"
import script from "./FocusButton.vue?vue&type=script&lang=js"
export * from "./FocusButton.vue?vue&type=script&lang=js"
import style0 from "./FocusButton.vue?vue&type=style&index=0&id=1b6e874b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6e874b",
  null
  
)

export default component.exports